import React from 'react';
import { CircleXIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const pains = ['Perdés horas redactando demandas y escritos desde cero.', 'Tenés que buscar modelos distintos para cada expediente.', 'Dudás sobre la mejor estrategia frente a la Ley 27.802.', 'Pasás horas buscando jurisprudencia actualizada.', 'Necesitás adaptar contratos y telegramas constantemente.'];
  return <section className="border-y border-white/10 bg-charcoal px-5 py-14 md:px-8 md:py-20" data-id="element-153" data-mp="1xzuczy6d2gr5">
      <div className="mx-auto max-w-3xl" data-id="element-154" data-mp="220o22uvji1lm">
        <FadeIn className="text-center" data-id="element-155" data-mp="1nztsi8wr9uld">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-accent" data-id="element-156" data-mp="1o14t5zuwmm89">
            La práctica cotidiana
          </p>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-157" data-mp="1t0hpdb7o15ni">
            Esto seguramente también te pasa
          </h2>
        </FadeIn>

        <div className="mt-8 space-y-3" data-id="element-158" data-mp="3nbcw07zaiann">
          {pains.map(pain => <div key={pain} className="flex items-center gap-3 border border-white/10 bg-ink px-4 py-4" data-id="element-159" data-mp="1yzvh7d06yfrt">
              <CircleXIcon size={19} className="shrink-0 text-red-300" aria-hidden="true" data-id="element-160" data-mp="1tzhiwmoe6k6z" />
              <p className="text-sm font-medium text-stone-200 md:text-base" data-id="element-161" data-mp="23sg8o7vmkgs6">
                {pain}
              </p>
            </div>)}
        </div>

        <FadeIn className="mt-8 text-center" data-id="element-162" data-mp="1b2ptdvi9b8uh">
          <p className="font-display text-xl font-bold text-white md:text-2xl" data-id="element-163" data-mp="1b417op9bvyzu">
            No necesitás más teoría.
          </p>
          <p className="mt-1 text-lg font-semibold text-accent md:text-xl" data-id="element-164" data-mp="1p0ecaxsrk5ww">
            Necesitás un sistema profesional de trabajo.
          </p>
        </FadeIn>
      </div>
    </section>;
}